import request from "@/utils/request"

export function getLinkList(params){
    return request({
        method:'get',
        url:'/link/link',
        params:params
    })
}